import React from 'react';
import styles from './FormTable.scss';

const MONTH_IN_MS = 1000 * 60 * 60 * 24 * 30;

let Row = ({
  title,
  notes = [],
  color = 'blue',
  onDelete,
  keyWidth,
  production,
}) => {

  return (
    <div className={styles.row}>
      <div className={styles.header}>
        <span className={[styles.indicator, styles[color]].join(' ')} />
        <span className={styles.title}>{title}</span>
        {typeof onDelete === 'function' ? <a href='javascript:;' role='button' className={styles.del} onClick={onDelete}>&times;</a> : null}
      </div>
      {notes.map(({ key, keyColor = '', value, strong }, index) => {
        return (
          <div key={index.toString()} className={styles.info}>
            <span style={{ width: keyWidth }} className={[styles.label, styles[keyColor]].join(' ')}>{key}</span>
            {strong ? <strong>{value}</strong> : <span className={styles.din}>{value}</span>}
          </div>
        );
      })}
    </div>
  );
};

let FormTable = ({ items, keyWidth = '100px' }) => (
  <div className={styles.table}>
    {items.map((item, index) => {
      return <Row key={index.toString()} keyWidth={keyWidth} {...item} />
    })
    }
  </div>
);

export default FormTable;
